import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AssignmentHistoryModel } from 'shared/components/assignment-history/models/assignment-history.model';
import * as moment from 'moment';

@Component({
  selector: 'app-assignment-history-item',
  templateUrl: './assignment-history-item.component.html',
  styleUrls: ['./assignment-history-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssignmentHistoryItemComponent {
  @Input()
  assignmentHistoryModel: AssignmentHistoryModel;
  @Input()
  collapsible: boolean;
  @Input()
  collapsed: boolean;

  public toggleCollapsed(): void {
    if (this.collapsible) {
      this.collapsed = !this.collapsed;
    }
  }

  public getFormattedDate(rawDate: string): string {
    if (!rawDate) {
      return '-';
    }

    return moment.utc(rawDate).local().format('MM/DD/YYYY hh:mm A');
  }

  public isReassigned(): boolean {
    return !!this.assignmentHistoryModel.reassignedBy && !!this.assignmentHistoryModel.reassignedTo;
  }
}
